import React from 'react'
import HomepageCarousel from './components/carousel/homepageCarousel'
import { Box } from '@mui/material'
import ContactForm from './components/contact/contactForm'
import WhyChooseUs from './components/sections/whyChooseUs'
import OneLineStrip from './components/sections/oneLineStrip'
import FeaturedPallets from './components/sections/featuredPallets'
import AboutSection from './components/sections/about'
import CtaBanner from './components/sections/cta'
import Testimonials from './components/sections/testimonials'
import './index.css'

const Homepage = () => (
  <Box width={1} sx={{ mx: 'auto' }}>
    <HomepageCarousel />
    <OneLineStrip />
    <FeaturedPallets />
    <WhyChooseUs />
    <AboutSection />
    <CtaBanner />
    <Testimonials />
    <Box>
      <ContactForm />
    </Box>
  </Box>
)

export default Homepage
